import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { SECONDS } from 'src/app/utils/date-time.utils';
import { SimpleLocalStorageCacheWrapper } from 'src/app/wrappers/simple-cache-wrapper';

@Injectable({
  providedIn: 'root'
})
export class CacheAdapter {
  private cache = this.cacheWrapper.getCache();

  constructor(private cacheWrapper: SimpleLocalStorageCacheWrapper) {}

  get(key: string): Observable<Object | null> {
    const getPromsie = this._get(key);
    const getObservable = from(getPromsie);

    return getObservable;
  }

  set(value: Object, key: string, expiration: SECONDS): Observable<void> {
    const valueJson = JSON.stringify(value);
    const setOptions = { secondsUntilExpiration: expiration };
    const setPromise = this.cache.set(key, valueJson, setOptions);
    const setObservable = from(setPromise);

    return setObservable;
  }

  private async _get<Type>(key: string): Promise<Type | null> {
    const valueJson = await this.cache.get(key);
    if (valueJson == null) {
      return undefined;
    }

    const deserializedValue = JSON.parse(valueJson) as Type;

    return deserializedValue;
  }
}
